import { Auth0Provider } from '@auth0/auth0-react';
import { auth0Config, AUTH_SCOPES } from '@feature/auth/constants/auth.constants';
import { AuthInterceptorProvider } from '@shared/providers/AuthInterceptorProvider';
import { UserProfileProvider } from '@feature/auth/contexts/UserProfileContext';

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <Auth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={{
        redirect_uri: `${window.location.origin}/callback`,
        audience: auth0Config.audience,
        scope: AUTH_SCOPES
      }}
      // Usar memoria en lugar de localStorage para evitar problemas con múltiples usuarios
      cacheLocation="memory"
      // Limpiar cache al iniciar sesión para evitar tokens antiguos
      useRefreshTokens={true}
      // Habilitar refresh tokens para mejor manejo de sesión
    >
      <AuthInterceptorProvider>
        <UserProfileProvider>
          {children}
        </UserProfileProvider>
      </AuthInterceptorProvider>
    </Auth0Provider>
  );
}; 